// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"313":"d51c38c8","5522":"404820ee"}[chunkId] + ".chunk.css";
};